(function($) {
  'use strict';

  if ($('html').hasClass('page-news')) {

    var news = {
      dom: function() {
        this.$wrap       = $('#newsWrapper');
        this.$form       = $('#newsFilters');
        this.$allFilters = this.$form.find(':input');
        this.$search     = $('#newsSearch');
        this.$sort       = $("#newsSort");
        this.$results    = $('#newsResults');
        this.$loader     = $('.page__loader', news.$wrap);
      },

      settings: {
        action: $('#newsFilters').attr('action')
      },

      filters: function() {
        var searchTimeout;

        this.$search.on('keyup input', function(event) {
          event.preventDefault();
          var $this = $(this);

          clearTimeout(searchTimeout);

          searchTimeout = setTimeout(function() {
            if ($this.val().length) {
              $this.parent().addClass('has-value');
            }
            else {
              $this.parent().removeClass('has-value');
            }
            news.$form.submit();
          }, 500);
        });

        this.$sort.on('change', function(event) {
          event.preventDefault();
          news.$form.submit();
        });

        $(document).on('click', '[data-js-hook="newsClearFilters"]', function(event) {
          event.preventDefault();
          $('[data-input-clear="newsSearch"]').trigger('click');
        });

        $(document).on('click', '[data-input-clear="newsSearch"]', function(event) {
          $('#featuredNews').show();
          $(this).hide();
        });

        this.$form.on('submit', function(event) {
          event.preventDefault();
          news.$loader.show();
          var $form = $(this);
          var action = $form.attr('action');

          // filter results
          news.$results.load(action, $form.serialize(), function() {
            news.$loader.hide();
          });

          // using URL params instead of localStorage
          window.history.pushState(false, false, action + '?' + $form.serialize());
        });
      },

      onPopState: function() {
        // -- Filter after history back/forward
        window.onpopstate = function() {
          var url = window.location.href;
          var params = url.replace(news.settings.action,"").replace(/^\/|\/$/g, '').replace('dev=1','').replace('?','');

          if (params.length) {
            params = params.split('&');
            params.forEach(function(string) {
              var param = string.split('=');
              $('[name="' + param[0] + '"]').val(param[1].replace('%20',' '));
            });
          }
          else {
            news.$sort.val(news.$sort.data('default'));
            news.$search.val('').trigger('input');
          }
        };
      },

      ready: function() {
        this.dom();
        this.filters();
        this.onPopState();
      }
    };

    $(function() { news.ready(); });

  }

})(jQuery);
